module.exports = __webpack_public_path__ + "static/media/pentagram.ae0e832e.webp";